import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { FaDollarSign } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import { PDFViewer } from "@react-pdf/renderer";

import { useParams } from "react-router-dom";
import PDFRender from "./PDFRender";
import MultiSelect from "../../../../../../components/common/MultiSelect";
import { data, purchaseOrderNumbers } from "../smartBillEntryData";
import Notes from "../../../../../../components/common/Notes";
import AttachmentsUpload from "../../../../../../components/common/AttachmentsUpload";
import RightBar from "../../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../../components/common/RightBar/RightBarMethod";

const ReadytoReviewRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Smart Bill Entry", "1", "", "", "/accounting/payables_bills/bills/smartbillentry"),
  ]),
  RightBarMethod(
    "Reports",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [RightBarMethod("Vendor Ledger", "2", "", "", "")]
  ),
  RightBarMethod(
    "HELP TOPICS",
    "t4",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Enter a Bill", "3", "", "", "")]
  ),
];

const ReadytoReview = () => {
  const [payee, setPayee] = useState("");
  const [isShowUtility, setIsShowUtility] = useState(false);
  const [isAllocation, setIsAllocation] = useState(false);
  const [user, setUser] = useState([]);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { id } = useParams();
  useEffect(() => {
    const test = data.find((u) => u.key == id);
    setUser(test);
    console.log(user);
  }, [user]);

  const onChange = (value) => {
    console.log(`selected ${value}`);
    setPayee(value);
  };

  const styles = {
    container: {
      height: "100%",
    },
    fullScreenContainer: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: "99999",
      background: "#f0f0f0",
      height: "200%",
    },
  };

  const initialList = [{ id: uuidv4() }];

  const [accounts, setAccounts] = useState(initialList);

  function handleAddAccount() {
    const newList = accounts.concat({ id: uuidv4() });
    setAccounts(newList);
  }

  function handleRemoveAccount(id) {
    const newList = accounts.filter((item) => item.id !== id);
    setAccounts(newList);
  }

  const handleShowUtility = (e) => {
    console.log(`checked = ${e.target.checked}`);
    setIsShowUtility(e.target.checked);
  };
  const handleAllocation = (e) => {
    console.log(`checked = ${e.target.checked}`);
    setIsAllocation(e.target.checked);
  };

  return (
    <>
      <div style={isFullScreen ? styles.fullScreenContainer : styles.container}>
        <div className="pageheading ">
          <h1>Smart Bill Entry</h1>
          <div className="pageHeadingBtns">
            <button onClick={() => setIsFullScreen(!isFullScreen)}>
              {" "}
              {isFullScreen ? (
                <p>
                  <i aria-hidden="true" className="fa fa-compress fa-fw pe-4"></i>
                  Normal Screen View
                </p>
              ) : (
                <p>
                  <i aria-hidden="true" className="fa fa-expand fa-fw pe-4"></i>Full
                  Screen View
                </p>
              )}
            </button>
          </div>
        </div>
        <Form
          name="basic"
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
          layout="vertical"
        >
          <Row gutter={16}>
            <Col span={10}>
              <Card>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item required>
                      <div className="labelForPay">
                        <label htmlFor="payee" required>
                          Payee
                        </label>
                        <a href="/people/vendors/new">Add New Vendor</a>
                      </div>
                      <Select
                        showSearch
                        allowClear
                        placeholder="Start typing to search"
                        optionFilterProp="children"
                        onChange={onChange}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={[
                          {
                            value:
                              "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                            label:
                              "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                          },
                          {
                            value:
                              "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
                            label:
                              "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
                          },
                          {
                            value: "AT&T - PO Box 5014  Carol Stream, IL 60197",
                            label: "AT&T - PO Box 5014  Carol Stream, IL 60197",
                          },
                        ]}
                      />
                    </Form.Item>

                    <Col span={10}>
                      <p>{payee}</p>
                    </Col>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item label="Total Amount" required>
                      <Input
                        placeholder="Amount"
                        addonBefore={<FaDollarSign size={12} />}
                        defaultValue={user.amount}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="Bill Date" required>
                      <DatePicker
                        format="MM-DD-YYYY"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Due Date" required>
                      <DatePicker
                        format="MM-DD-YYYY"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item label="Posting Date">
                      <DatePicker
                        format="MM-DD-YYYY"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item>
                      <Checkbox onChange={handleShowUtility}>
                        Show Utility Bill View
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                {isShowUtility ? (
                  <>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item label="Account Number">
                          <Input placeholder="e.g. 123456789-2" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item label="Purchase Order #">
                          <MultiSelect
                            options={purchaseOrderNumbers}
                            placeholder="Search by Payees"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item label="Work Order">
                          <Select
                            showSearch
                            allowClear
                            placeholder="Start typing to search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={[
                              {
                                value:
                                  "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                                label:
                                  "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                              },
                              {
                                value:
                                  "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
                                label:
                                  "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
                              },
                              {
                                value:
                                  "AT&T - PO Box 5014  Carol Stream, IL 60197",
                                label:
                                  "AT&T - PO Box 5014  Carol Stream, IL 60197",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item label="Reference">
                      <Input placeholder="e.g. Invoice #123" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item label="Remarks">
                      <Input placeholder="e.g. November Bill" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="Cash Account">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Automatic"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={[
                          {
                            value: "23931: Rental Income Account",
                            label: "23931: Rental Income Account",
                          },
                          {
                            value: "23932: Security Deposits Bank Accounts",
                            label: "23932: Security Deposits Bank Accounts",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Memo for Check">
                      <Input placeholder="e.g. Account #123456" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item>
                      <Checkbox onChange={handleAllocation}>
                        Allocation
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                {isAllocation ? (
                  <>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item label="Properties">
                          <Select
                            showSearch
                            allowClear
                            placeholder="Search by group, owner, portfolio"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={[
                              {
                                value: "23931: Rental Income Account",
                                label: "23931: Rental Income Account",
                              },
                              {
                                value: "23932: Security Deposits Bank Accounts",
                                label: "23932: Security Deposits Bank Accounts",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label="GL Account">
                          <Select
                            showSearch
                            allowClear
                            placeholder="Start typing to search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={[
                              {
                                value: "23931: Rental Income Account",
                                label: "23931: Rental Income Account",
                              },
                              {
                                value: "23932: Security Deposits Bank Accounts",
                                label: "23932: Security Deposits Bank Accounts",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label="Description">
                          <Input placeholder="e.g. Landscaping" />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label="Allocation Type">
                          <Select
                            showSearch
                            allowClear
                            placeholder="Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={[
                              {
                                value: "Unit Count",
                                label: "Unit Count",
                              },
                              {
                                value: "Square Feet",
                                label: "Square Feet",
                              },
                              {
                                value: "Rental Income",
                                label: "Rental Income",
                              },
                              {
                                value: "Even spread",
                                label: "Even spread",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
                <Divider />
                <Row gutter={16}>
                  <h4>Line Items</h4>

                  <ul>
                    {accounts.map((item) => (
                      <li key={item.id}>
                        <Form.Item label="">
                          <Row gutter={16} justify="space-between">
                            <Col span={accounts.length > 1 ? 22 : 24}>
                              <Row gutter={16}>
                                <Col span={24}>
                                  <Form.Item label="Property" required>
                                    <Select
                                      showSearch
                                      placeholder="Start typing to search"
                                      style={{ width: "100%" }}
                                      disabled={isAllocation ? true : false}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={24}>
                                  <Form.Item label="Unit">
                                    <Select
                                      showSearch
                                      placeholder="Start typing to search"
                                      style={{ width: "100%" }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={24}>
                                  <Form.Item label="GL Account" required>
                                    <Select
                                      showSearch
                                      placeholder="Start typing to search"
                                      style={{ width: "100%" }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={24}>
                                  <Form.Item label="Description">
                                    <Input />
                                  </Form.Item>
                                </Col>
                                <Col span={24}>
                                  <Form.Item label="Amount" required>
                                    <Input
                                      placeholder="Amount"
                                      addonBefore={<FaDollarSign size={12} />}
                                      defaultValue={user.amount}
                                    />
                                  </Form.Item>
                                </Col>
                                {isShowUtility ? (
                                  <>
                                    <Col span={12}>
                                      <Form.Item label="Service From" required>
                                        <DatePicker
                                          format="MM-DD-YYYY"
                                          style={{ width: "100%" }}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                      <Form.Item label="Service To" required>
                                        <DatePicker
                                          format="MM-DD-YYYY"
                                          style={{ width: "100%" }}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </Col>

                            <Col span={1}>
                              {accounts.length > 1 ? (
                                <Button
                                  className="roundSmallButton"
                                  onClick={() => {
                                    handleRemoveAccount(item.id);
                                  }}
                                  type="primary"
                                  shape="square"
                                  icon={
                                    <i className="fa-regular fa-circle-xmark"></i>
                                  }
                                  size={"small"}
                                  style={{
                                    height: "100%",
                                    border: "1px solid red",
                                    background: "transparent",
                                    color: "red",
                                  }}
                                />
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                        </Form.Item>
                      </li>
                    ))}

                    <Form.Item label="">
                      <Button
                        className="addPropertyGroupButton"
                        onClick={handleAddAccount}
                        size={"small"}
                        icon={<i className="fa-solid fa-circle-plus"></i>}
                      >
                        {" "}
                        Add Another Line
                      </Button>
                    </Form.Item>

                    <Row gutter={16} justify="end">
                      <Col span={4}>
                        <p>
                          <b>Total:</b>{" "}
                        </p>
                      </Col>
                      <Col span={8} style={{ textAlign: "right" }}>
                        <p>
                          <b> $ {"0.00"}</b>
                        </p>
                      </Col>
                    </Row>
                  </ul>
                </Row>
                <Divider />
                <Row>
                  <Col span={24}>
                    <Form.Item>
                      <Button type="primary" style={{ width: "100%" }}>
                        {" "}
                        Save & Review Next
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify="space-between">
                  <Col span={14}>
                    <Row gutter={16}>
                      <Col>
                        <Form.Item>
                          <Button style={{ width: "100%" }}> Save</Button>
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item>
                          <Button style={{ width: "100%" }}> Skip</Button>
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item>
                          <Button type="link" style={{ width: "100%" }}>
                            {" "}
                            Cancel
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Form.Item>
                      <Button type="text" danger style={{ width: "100%" }}>
                        {" "}
                        Delete
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col span={14}>
              <PDFViewer style={{ width: "100%", height: "100vh" }}>
                <PDFRender user={user} />
              </PDFViewer>
            </Col>
          </Row>
        </Form>
        <br />
        {/* <Notes /> */}
        {/* <AttachmentsUpload /> */}
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ReadytoReviewRightBar} />
      </div>
    </>
  );
};

export default ReadytoReview;
